import { render, staticRenderFns } from "./fePermalink.vue?vue&type=template&id=2b676b54&"
import script from "./fePermalink.vue?vue&type=script&lang=js&"
export * from "./fePermalink.vue?vue&type=script&lang=js&"
import style0 from "./fePermalink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports